export interface PriceDataInterface {
  priceKey: string;
  amount: number;
  currency: string;
}

export interface productDataInterface {
  id: string
  isFree: boolean
  prices?: {
    [key: string]: PriceDataInterface,
  }
  addons: productDataInterface[]
  requiresQuantity: boolean
  description: string[]
}

export interface productOptionsDataInterface {
  [key: string]: productDataInterface
}

export const productHostedMeeting = {
  id: 'prod_tl_hosted-meetings-2025-aXAzm5papy2Y',
  isFree: false,
  prices: {
    month: {
      priceKey: 'tl_hosted-meetings-monthly',
      amount: 10,
      currency: 'AUD',
    },
    year: {
      priceKey: 'tl_hosted-meetings-yearly',
      amount: 96,
      currency: 'AUD',
    },
  },
  addons: [],
  requiresQuantity: false,
  description: ['Custom Voice / Video Rooms'],
};

export const productFree: productDataInterface = {
  id: 'free',
  isFree: true,
  prices: {
    month: {
      priceKey: 'free',
      amount: 0,
      currency: 'AUD',
    },
    year: {
      priceKey: 'free',
      amount: 0,
      currency: 'AUD',
    },
  },
  addons: [],
  requiresQuantity: false,
  description: [
    "Unique Link & QR Code (Eg. triplink.vip/123456)",
    "Landing Page & Profile",
    "Automated Trip info. collection form",
    "Lead management portal",
    "Lead email notification",
    "Up to 50 monthly lead collects"
  ],
};

export const productIndividual: productDataInterface = {
  id: 'prod_tl_individual-2025-wGCk4x2O6p3j',
  isFree: false,
  prices: {
    month: {
      priceKey: 'tl_individual-monthly',
      amount: 15,
      currency: 'AUD',
    },
    year: {
      priceKey: 'tl_individual-yearly',
      amount: 144,
      currency: 'AUD',
    },
  },
  addons: [productHostedMeeting],
  requiresQuantity: false,
  description: [
    "Calendar & Meeting Availability",
    "Customer Meeting Time Selector",
    "External Calendar Sync (Google, Microsoft)",
    "BYO Video / Voice Room link (EG. Google meet, MS Teams, Zoom link)",
    "Unlimited monthly lead collects",
  ],
};

export const productBusiness: productDataInterface = {
  id: 'prod_tl_business-2025-N9kH4gDqXydb',
  isFree: false,
  prices: {
    month: {
      priceKey: 'tl_business-monthly',
      amount: 25,
      currency: 'AUD',
    },
    year: {
      priceKey: 'tl_business-yearly',
      amount: 240,
      currency: 'AUD',
    },
  },
  addons: [productHostedMeeting],
  requiresQuantity: true,
  description: [
    "Business sub-domain. Includes brand landing page and colour (Eg. triplink.vip/bus_name)",
    "Branded team users links (Eg. triplink.vip/bus_name/123456)",
    "Team user administration",
    "Aggregated lead management",
    "Aggregated calendar view",
    "Multiple BYO Video / Voice Room links (EG. Google meet, MS Teams, Zoom link)",
    "Enhanced support",
  ],
};

export const productEnterprise: productDataInterface = {
  id: 'enterprise',
  isFree: false,
  prices: {},
  addons: [],
  requiresQuantity: false,
  description: [
    "API Access",
    "CRM Integration",
    "Service Customisation",
    "Custom Professional Services",
  ],
};

export const productOptions: productOptionsDataInterface = {
  free: productFree,
  'prod_tl_individual-2025-wGCk4x2O6p3j': productIndividual,
  'prod_tl_business-2025-N9kH4gDqXydb': productBusiness,
  enterprise: productEnterprise,
};

export interface ProductChangeOptionsInterface {
  [key: string]: {
    baseProducts: productDataInterface[];
  };
}

export const productUpgradeOptions: ProductChangeOptionsInterface = {
  free: {
    baseProducts: [productIndividual, productBusiness],
  },
  'prod_tl_individual-2025-wGCk4x2O6p3j': {
    baseProducts: [productBusiness],
  },
  'prod_tl_business-2025-N9kH4gDqXydb': {
    baseProducts: [],
  },
};

export const productDowngradeOptions: ProductChangeOptionsInterface = {
  free: {
    baseProducts: [],
  },
  'prod_tl_individual-2025-wGCk4x2O6p3j': {
    baseProducts: [productFree],
  },
  'prod_tl_business-2025-N9kH4gDqXydb': {
    baseProducts: [],
  },
};
